export const CATEGORY_LIST_PAGE_SIZE = 50;
export const CATEGORY_DETAILS_CONTENT_PAGE_SIZE = 50;
export const CATEGORY_LIST_CONTENT_PAGE_SIZE = 3;

export const CATEGORY_CONTENT_VIEW_TYPE = {
  CATEGORY_LIST: "CategoryList",
  CATEGORY_DETAILS: "CategoryDetails",
  RESOURCE_DETAILS: "ResourceDetails",
};
